export function buildChallengeMapRoutes(currentRoutes, currentIndex, challengeId) {
    return [
        // 현재 보고 있는 화면까지만 남긴다 — index 뒤쪽은 forward 히스토리라 버린다.
        ...currentRoutes.slice(0, currentIndex + 1),
        { name: 'ChallengeDetail', params: { challengeId } },
        {
            name: 'ChallengeConquerTargetPlaces',
            params: { challengeId, initialViewMode: 'map' },
        },
    ];
}
